import { Injectable, Inject } from '@angular/core';
import { APIClientService } from '@registration/services/api-client.service';
import { APP_CONFIG } from '../resources/config';

@Injectable()
export class UserIdentityVerifyService {
  newProfileInfo: any;

  constructor(
    private apiClient: APIClientService,
    @Inject(APP_CONFIG) private config: any,
  ) {}

  getUser(email, reviewReferenceNumber) {
    const body = {
      email,
      reviewReferenceNumber,
    };
    return this.apiClient.doPost(this.config.getUserAPI, body);
  }

  createOktaUser(reqBody) {
    const url = this.config.userCreationAPI;
    return this.apiClient.doPost(this.config.userCreationAPI, reqBody);
  }
  verifyFARSFlow({ referenceId, email }) {
    const body = {
      clientReferenceId: referenceId,
      email,
    };
    return this.apiClient.doPost(this.config.verifyUserAPI, body);
  }
}
